import React, { useState } from 'react';
import { Menu, X, ChevronDown, ChevronRight, ExternalLink, Hash, Facebook, Twitter, Instagram, Linkedin, Youtube, Mail, Globe } from 'lucide-react';
import { Button } from './ui/button';

// Social Media Icons Component
const SocialIcon = ({ platform, size = 20, color = 'currentColor' }) => {
  // Bluesky butterfly SVG (custom, not in Lucide)
  const BlueskyIcon = () => (
    <svg viewBox="0 0 600 530" width={size} height={size} fill={color}>
      <path d="M135.72 44.03C202.216 93.951 273.74 195.17 300 249.49c26.262-54.316 97.782-155.54 164.28-205.46C512.26 8.009 590-19.862 590 68.825c0 17.712-10.155 148.79-16.111 170.07-20.703 73.984-96.144 92.854-163.25 81.433 117.3 19.964 147.14 86.092 82.697 152.22-122.39 125.59-175.91-31.511-189.63-71.766-2.514-7.38-3.69-10.832-3.708-7.896-.017-2.936-1.193.516-3.707 7.896-13.714 40.255-67.233 197.36-189.63 71.766-64.444-66.128-34.605-132.26 82.697-152.22-67.108 11.421-142.55-7.449-163.25-81.433C20.15 217.613 10 86.536 10 68.824c0-88.687 77.742-60.816 125.72-24.795z"/>
    </svg>
  );
  
  // TikTok SVG (custom, not in Lucide)
  const TikTokIcon = () => (
    <svg viewBox="0 0 24 24" width={size} height={size} fill={color}>
      <path d="M12.525.02c1.31-.02 2.61-.01 3.91-.02.08 1.53.63 3.09 1.75 4.17 1.12 1.11 2.7 1.62 4.24 1.79v4.03c-1.44-.05-2.89-.35-4.2-.97-.57-.26-1.1-.59-1.62-.93-.01 2.92.01 5.84-.02 8.75-.08 1.4-.54 2.79-1.35 3.94-1.31 1.92-3.58 3.17-5.91 3.21-1.43.08-2.86-.31-4.08-1.03-2.02-1.19-3.44-3.37-3.65-5.71-.02-.5-.03-1-.01-1.49.18-1.9 1.12-3.72 2.58-4.96 1.66-1.44 3.98-2.13 6.15-1.72.02 1.48-.04 2.96-.04 4.44-.99-.32-2.15-.23-3.02.37-.63.41-1.11 1.04-1.36 1.75-.21.51-.15 1.07-.14 1.61.24 1.64 1.82 3.02 3.5 2.87 1.12-.01 2.19-.66 2.77-1.61.19-.33.4-.67.41-1.06.1-1.79.06-3.57.07-5.36.01-4.03-.01-8.05.02-12.07z"/>
    </svg>
  );
  
  // Pinterest SVG (custom, not in Lucide)
  const PinterestIcon = () => (
    <svg viewBox="0 0 24 24" width={size} height={size} fill={color}>
      <path d="M12.017 0C5.396 0 .029 5.367.029 11.987c0 5.079 3.158 9.417 7.618 11.162-.105-.949-.199-2.403.041-3.439.219-.937 1.406-5.957 1.406-5.957s-.359-.72-.359-1.781c0-1.663.967-2.911 2.168-2.911 1.024 0 1.518.769 1.518 1.688 0 1.029-.653 2.567-.992 3.992-.285 1.193.6 2.165 1.775 2.165 2.128 0 3.768-2.245 3.768-5.487 0-2.861-2.063-4.869-5.008-4.869-3.41 0-5.409 2.562-5.409 5.199 0 1.033.394 2.143.889 2.741.099.12.112.225.085.345-.09.375-.293 1.199-.334 1.363-.053.225-.172.271-.401.165-1.495-.69-2.433-2.878-2.433-4.646 0-3.776 2.748-7.252 7.92-7.252 4.158 0 7.392 2.967 7.392 6.923 0 4.135-2.607 7.462-6.233 7.462-1.214 0-2.354-.629-2.758-1.379l-.749 2.848c-.269 1.045-1.004 2.352-1.498 3.146 1.123.345 2.306.535 3.55.535 6.607 0 11.985-5.365 11.985-11.987C23.97 5.39 18.592.026 11.985.026L12.017 0z"/>
    </svg>
  );
  
  // GitHub SVG (custom, not in Lucide)
  const GitHubIcon = () => (
    <svg viewBox="0 0 24 24" width={size} height={size} fill={color}>
      <path d="M12 .297c-6.63 0-12 5.373-12 12 0 5.303 3.438 9.8 8.205 11.385.6.113.82-.258.82-.577 0-.285-.01-1.04-.015-2.04-3.338.724-4.042-1.61-4.042-1.61C4.422 18.07 3.633 17.7 3.633 17.7c-1.087-.744.084-.729.084-.729 1.205.084 1.838 1.236 1.838 1.236 1.07 1.835 2.809 1.305 3.495.998.108-.776.417-1.305.76-1.605-2.665-.3-5.466-1.332-5.466-5.93 0-1.31.465-2.38 1.235-3.22-.135-.303-.54-1.523.105-3.176 0 0 1.005-.322 3.3 1.23.96-.267 1.98-.399 3-.405 1.02.006 2.04.138 3 .405 2.28-1.552 3.285-1.23 3.285-1.23.645 1.653.24 2.873.12 3.176.765.84 1.23 1.91 1.23 3.22 0 4.61-2.805 5.625-5.475 5.92.42.36.81 1.096.81 2.22 0 1.606-.015 2.896-.015 3.286 0 .315.21.69.825.57C20.565 22.092 24 17.592 24 12.297c0-6.627-5.373-12-12-12"/>
    </svg>
  );
  
  const icons = {
    facebook: <Facebook size={size} color={color} />,
    twitter: <Twitter size={size} color={color} />,
    instagram: <Instagram size={size} color={color} />,
    linkedin: <Linkedin size={size} color={color} />,
    youtube: <Youtube size={size} color={color} />,
    bluesky: <BlueskyIcon />,
    tiktok: <TikTokIcon />,
    pinterest: <PinterestIcon />,
    github: <GitHubIcon />,
    email: <Mail size={size} color={color} />,
    website: <Globe size={size} color={color} />,
  };
  return icons[platform] || <Globe size={size} color={color} />;
};

const MenuPreview = ({ menu, siteTheme, pages }) => {
  const [hamburgerOpen, setHamburgerOpen] = useState(false);
  const [openDropdowns, setOpenDropdowns] = useState({});

  const getThemeValue = (key, defaultValue) => {
    if (menu.theme_override && menu.theme_override[key]) {
      return menu.theme_override[key];
    }
    if (siteTheme && siteTheme[key]) {
      return siteTheme[key];
    }
    return defaultValue;
  };

  const backgroundColor = getThemeValue('backgroundColor', getThemeValue('background_color', '#ffffff'));
  const textColor = getThemeValue('textColor', getThemeValue('body_color', '#475569'));
  const accentColor = getThemeValue('accentColor', getThemeValue('primary_color', '#6366f1'));
  const hoverColor = getThemeValue('hoverColor', getThemeValue('link_hover_color', '#4f46e5'));

  const getPageSlug = (pageId) => {
    const page = pages?.find(p => p.page_id === pageId);
    return page ? `/${page.slug}` : '#';
  };

  const getLink = (item) => {
    if (item.link_type === 'external') {
      return item.link_value || '#';
    }
    if (item.link_type === 'anchor') {
      return `#${item.link_value?.replace(/^#/, '') || ''}`;
    }
    return item.link_value ? getPageSlug(item.link_value) : '#';
  };

  const toggleDropdown = (itemId) => {
    setOpenDropdowns(prev => ({
      ...prev,
      [itemId]: !prev[itemId]
    }));
  };

  const renderHorizontalMenu = () => {
    const renderItem = (item, depth = 0) => {
      const hasChildren = item.children?.length > 0;
      const isOpen = openDropdowns[item.item_id];

      // Render as button if is_button is set
      if (item.is_button) {
        const btnBg = item.button_bg_color || accentColor;
        const btnText = item.button_text_color || '#ffffff';
        const btnStyle = item.button_style || 'solid';
        const btnRadius = item.button_border_radius === 'pill' ? '9999px' : item.button_border_radius === 'square' ? '2px' : '6px';
        let btnInlineStyle;
        if (btnStyle === 'outline') {
          btnInlineStyle = { background: 'transparent', color: btnBg, border: `1.5px solid ${btnBg}`, borderRadius: btnRadius };
        } else if (btnStyle === 'ghost') {
          btnInlineStyle = { background: `${btnBg}18`, color: btnBg, borderRadius: btnRadius };
        } else {
          btnInlineStyle = { backgroundColor: btnBg, color: btnText, borderRadius: btnRadius };
        }
        return (
          <div key={item.item_id} className="flex items-center">
            <a
              href={getLink(item)}
              target={item.target}
              className="inline-flex items-center gap-1 px-4 py-1.5 text-sm font-semibold transition-all hover:opacity-80"
              style={btnInlineStyle}
            >
              {item.label}
            </a>
          </div>
        );
      }

      return (
        <div key={item.item_id} className="relative group">
          <a
            href={getLink(item)}
            target={item.target}
            onClick={(e) => {
              if (hasChildren) {
                e.preventDefault();
                toggleDropdown(item.item_id);
              }
            }}
            className="flex items-center gap-1 px-4 py-2 rounded-md transition-colors hover:bg-black/5"
            style={{ color: textColor }}
            onMouseEnter={(e) => e.target.style.color = hoverColor}
            onMouseLeave={(e) => e.target.style.color = textColor}
          >
            <span>{item.label}</span>
            {hasChildren && <ChevronDown size={14} />}
            {item.link_type === 'external' && <ExternalLink size={12} className="ml-1 opacity-50" />}
            {item.link_type === 'anchor' && <Hash size={12} className="ml-1 opacity-50" />}
          </a>

          {hasChildren && isOpen && (
            <div
              className="absolute top-full left-0 mt-1 py-2 min-w-[200px] rounded-lg shadow-lg border z-50"
              style={{ backgroundColor, borderColor: 'rgba(0,0,0,0.1)' }}
            >
              {item.children.map((child) => renderDropdownItem(child, depth + 1))}
            </div>
          )}
        </div>
      );
    };

    const renderDropdownItem = (item, depth) => {
      const hasChildren = item.children?.length > 0;
      const isOpen = openDropdowns[item.item_id];

      return (
        <div key={item.item_id} className="relative">
          <a
            href={getLink(item)}
            target={item.target}
            onClick={(e) => {
              if (hasChildren) {
                e.preventDefault();
                toggleDropdown(item.item_id);
              }
            }}
            className="flex items-center justify-between px-4 py-2 transition-colors hover:bg-black/5"
            style={{ color: textColor }}
            onMouseEnter={(e) => e.target.style.color = hoverColor}
            onMouseLeave={(e) => e.target.style.color = textColor}
          >
            <span>{item.label}</span>
            {hasChildren && <ChevronRight size={14} />}
          </a>

          {hasChildren && isOpen && (
            <div
              className="absolute left-full top-0 ml-1 py-2 min-w-[180px] rounded-lg shadow-lg border z-50"
              style={{ backgroundColor, borderColor: 'rgba(0,0,0,0.1)' }}
            >
              {item.children.map((grandchild) => (
                <a
                  key={grandchild.item_id}
                  href={getLink(grandchild)}
                  target={grandchild.target}
                  className="block px-4 py-2 transition-colors hover:bg-black/5"
                  style={{ color: textColor }}
                  onMouseEnter={(e) => e.target.style.color = hoverColor}
                  onMouseLeave={(e) => e.target.style.color = textColor}
                >
                  {grandchild.label}
                </a>
              ))}
            </div>
          )}
        </div>
      );
    };

    // Get alignment classes
    const getAlignmentClass = () => {
      switch (menu.items_align) {
        case 'center': return 'justify-center';
        case 'right': return 'justify-end';
        default: return 'justify-start';
      }
    };

    return (
      <nav
        className={`flex items-center gap-1 px-4 py-3 rounded-lg ${getAlignmentClass()}`}
        style={{ backgroundColor }}
      >
        {menu.items?.map((item) => renderItem(item))}
      </nav>
    );
  };

  const renderHamburgerMenu = () => {
    // Match the actual site rendering as closely as possible:
    // • hamburger button position respects `hamburger_align`
    // • dropdown items inherit the same alignment
    const align = menu.hamburger_align || 'right';
    const headerJustify =
      align === 'right' ? 'justify-end' :
      align === 'center' ? 'justify-center' : 'justify-start';
    const itemJustify =
      align === 'right' ? 'justify-end' :
      align === 'center' ? 'justify-center' : 'justify-start';
    const itemTextAlign = align;

    const renderMobileItem = (item, depth = 0) => {
      const hasChildren = item.children?.length > 0;
      const isOpen = openDropdowns[item.item_id];

      return (
        <div key={item.item_id} style={{ textAlign: itemTextAlign }}>
          <a
            href={getLink(item)}
            target={item.target}
            onClick={(e) => {
              if (hasChildren) {
                e.preventDefault();
                toggleDropdown(item.item_id);
              }
            }}
            className={`flex items-center ${itemJustify} gap-2 px-4 py-3 border-b transition-colors`}
            style={{
              color: textColor,
              borderColor: 'rgba(0,0,0,0.1)'
            }}
          >
            <span>{item.label}</span>
            {hasChildren && (isOpen ? <ChevronDown size={16} /> : <ChevronRight size={16} />)}
          </a>

          {hasChildren && isOpen && (
            <div className="bg-black/5" style={{ paddingLeft: depth === 0 ? 16 : 0 }}>
              {item.children.map((child) => renderMobileItem(child, depth + 1))}
            </div>
          )}
        </div>
      );
    };

    return (
      <div>
        <div
          className={`flex items-center ${headerJustify} px-4 py-3 rounded-t-lg`}
          style={{ backgroundColor }}
        >
          <Button
            variant="ghost"
            size="sm"
            onClick={() => setHamburgerOpen(!hamburgerOpen)}
            style={{ color: textColor }}
            data-testid="menu-preview-hamburger-toggle"
          >
            {hamburgerOpen ? <X size={20} /> : <Menu size={20} />}
          </Button>
        </div>

        {hamburgerOpen && (
          <div
            className="rounded-b-lg border-t overflow-hidden"
            style={{ backgroundColor, borderColor: 'rgba(0,0,0,0.1)' }}
          >
            {menu.items?.map((item) => renderMobileItem(item))}
          </div>
        )}
      </div>
    );
  };

  const renderSidebarMenu = () => {
    const renderSidebarItem = (item, depth = 0) => {
      const hasChildren = item.children?.length > 0;
      const isOpen = openDropdowns[item.item_id];

      return (
        <div key={item.item_id}>
          <a
            href={getLink(item)}
            target={item.target}
            onClick={(e) => {
              if (hasChildren) {
                e.preventDefault();
                toggleDropdown(item.item_id);
              }
            }}
            className="flex items-center justify-between px-4 py-3 rounded-lg mb-1 transition-colors"
            style={{ 
              color: textColor,
              paddingLeft: 16 + depth * 12,
              backgroundColor: depth > 0 ? 'rgba(0,0,0,0.03)' : 'transparent'
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.backgroundColor = 'rgba(0,0,0,0.05)';
              e.currentTarget.style.color = hoverColor;
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.backgroundColor = depth > 0 ? 'rgba(0,0,0,0.03)' : 'transparent';
              e.currentTarget.style.color = textColor;
            }}
          >
            <span>{item.label}</span>
            {hasChildren && (isOpen ? <ChevronDown size={16} /> : <ChevronRight size={16} />)}
          </a>

          {hasChildren && isOpen && (
            <div className="ml-2">
              {item.children.map((child) => renderSidebarItem(child, depth + 1))}
            </div>
          )}
        </div>
      );
    };

    return (
      <nav
        className="w-64 min-h-[300px] p-4 rounded-lg"
        style={{ backgroundColor }}
      >
        <div className="font-semibold mb-4 px-4" style={{ color: textColor }}>
          {menu.name}
        </div>
        {menu.items?.map((item) => renderSidebarItem(item))}
      </nav>
    );
  };

  // Render footer menu preview with all footer settings
  const renderFooterMenu = () => {
    const footerSettings = menu.footer_settings || {};
    const layout = footerSettings.layout || 'simple';
    const sections = footerSettings.sections || [];
    const showCopyright = footerSettings.show_copyright !== false;
    const copyrightText = footerSettings.copyright_text || `© ${new Date().getFullYear()} All rights reserved`;
    const socialLinks = footerSettings.social_links || [];
    const paddingTop = footerSettings.padding_top || 48;
    const paddingBottom = footerSettings.padding_bottom || 32;
    const marginTopValue = footerSettings.margin_top ?? 48;
    const sectionTitleColor = footerSettings.section_title_color || textColor;
    const copyrightColor = footerSettings.copyright_color || textColor;
    const linkColor = footerSettings.link_color || textColor;
    const contentAlign = footerSettings.content_align || (layout === 'columns' ? 'left' : 'center');
    const alignTextClass = contentAlign === 'right' ? 'text-right' : contentAlign === 'left' ? 'text-left' : 'text-center';
    const alignItemsClass = contentAlign === 'right' ? 'items-end' : contentAlign === 'left' ? 'items-start' : 'items-center';
    const alignJustifyClass = contentAlign === 'right' ? 'justify-end' : contentAlign === 'left' ? 'justify-start' : 'justify-center';

    return (
      <footer 
        className="w-full rounded-lg"
        style={{ 
          backgroundColor,
          paddingTop: `${paddingTop}px`,
          paddingBottom: `${paddingBottom}px`,
          marginTop: `${marginTopValue}px`,
        }}
      >
        <div className="max-w-4xl mx-auto px-4">
          {/* Columns Layout */}
          {layout === 'columns' && sections.length > 0 && (
            <div className={`grid gap-6 mb-6 ${
              sections.length === 1 ? 'grid-cols-1 md:grid-cols-2' :
              sections.length === 2 ? 'grid-cols-1 md:grid-cols-3' :
              'grid-cols-1 md:grid-cols-4'
            }`}>
              {/* Logo Column */}
              {menu.logo?.url && (
                <div className="space-y-4">
                  <img 
                    src={menu.logo.url} 
                    alt="Logo"
                    style={{ height: `${menu.logo.height || 40}px`, width: 'auto', ...(menu.logo.maxWidth ? { maxWidth: `${menu.logo.maxWidth}px` } : {}), objectFit: 'contain' }}
                  />
                </div>
              )}
              
              {/* Content Sections */}
              {sections.map((section) => (
                <div key={section.section_id} className={`space-y-2 ${alignTextClass}`}>
                  {section.title && (
                    <h4 className="font-semibold text-sm uppercase tracking-wide" style={{ color: sectionTitleColor }}>
                      {section.title}
                    </h4>
                  )}
                  {section.content_html && (
                    <div 
                      className="text-sm space-y-1"
                      style={{ color: textColor, opacity: 0.9 }}
                      dangerouslySetInnerHTML={{ __html: section.content_html }}
                    />
                  )}
                  {/* Section Links */}
                  {section.links && section.links.length > 0 && (
                    <nav className={`flex flex-col gap-1 mt-2 ${alignItemsClass}`}>
                      {section.links.map(link => (
                        <a
                          key={link.link_id}
                          href="#"
                          className="text-sm hover:underline"
                          style={{ color: linkColor, opacity: footerSettings.link_color ? 1 : 0.9 }}
                        >
                          {link.label}
                        </a>
                      ))}
                    </nav>
                  )}
                </div>
              ))}
              
              {/* Links Column */}
              {menu.items?.length > 0 && (
                <div className={`space-y-2 ${alignTextClass}`}>
                  <h4 className="font-semibold text-sm uppercase tracking-wide" style={{ color: sectionTitleColor }}>
                    Quick Links
                  </h4>
                  <nav className={`flex flex-col gap-1 ${alignItemsClass}`}>
                    {menu.items.map(item => (
                      <a
                        key={item.item_id}
                        href={getLink(item)}
                        target={item.target || (item.link_type === 'external' ? '_blank' : undefined)}
                        rel={item.link_type === 'external' ? 'noopener noreferrer' : undefined}
                        className="text-sm hover:underline"
                        style={{ color: linkColor, opacity: footerSettings.link_color ? 1 : 0.9 }}
                      >
                        {item.label}
                      </a>
                    ))}
                  </nav>
                </div>
              )}
            </div>
          )}

          {/* Stacked Layout */}
          {layout === 'stacked' && sections.length > 0 && (
            <div className="mb-6 space-y-4">
              {/* Logo */}
              {menu.logo?.url && (
                <div className="flex justify-center">
                  <img 
                    src={menu.logo.url} 
                    alt="Logo"
                    style={{ height: `${menu.logo.height || 40}px`, width: 'auto', ...(menu.logo.maxWidth ? { maxWidth: `${menu.logo.maxWidth}px` } : {}), objectFit: 'contain' }}
                  />
                </div>
              )}
              
              {/* Content Sections */}
              <div className={`grid gap-4 ${
                sections.length === 1 ? 'grid-cols-1' :
                sections.length === 2 ? 'grid-cols-1 md:grid-cols-2' :
                'grid-cols-1 md:grid-cols-3'
              }`}>
                {sections.map((section) => (
                  <div key={section.section_id} className={alignTextClass}>
                    {section.title && (
                      <h4 className="font-semibold text-sm uppercase tracking-wide mb-2" style={{ color: sectionTitleColor }}>
                        {section.title}
                      </h4>
                    )}
                    {section.content_html && (
                      <div 
                        className="text-sm"
                        style={{ color: textColor, opacity: 0.9 }}
                        dangerouslySetInnerHTML={{ __html: section.content_html }}
                      />
                    )}
                    {/* Section Links */}
                    {section.links && section.links.length > 0 && (
                      <nav className={`flex flex-col gap-1 mt-2 ${alignItemsClass}`}>
                        {section.links.map(link => (
                          <a
                            key={link.link_id}
                            href="#"
                            className="text-sm hover:underline"
                            style={{ color: linkColor, opacity: footerSettings.link_color ? 1 : 0.9 }}
                          >
                            {link.label}
                          </a>
                        ))}
                      </nav>
                    )}
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Simple Layout - Logo and Links */}
          {(layout === 'simple' || sections.length === 0) && (
            <>
              {menu.logo?.url && (
                <div className="flex justify-center mb-4">
                  <img 
                    src={menu.logo.url} 
                    alt="Logo"
                    style={{ height: `${menu.logo.height || 40}px`, width: 'auto', ...(menu.logo.maxWidth ? { maxWidth: `${menu.logo.maxWidth}px` } : {}), objectFit: 'contain' }}
                  />
                </div>
              )}
            </>
          )}
          
          {/* Navigation Links (for simple/stacked layouts) */}
          {layout !== 'columns' && menu.items?.length > 0 && (
                        <nav className={`flex flex-wrap gap-4 mb-4 ${alignJustifyClass}`}>
              {menu.items.map(item => (
                <a
                  key={item.item_id}
                  href={getLink(item)}
                  target={item.target || (item.link_type === 'external' ? '_blank' : undefined)}
                  rel={item.link_type === 'external' ? 'noopener noreferrer' : undefined}
                  className="text-sm hover:underline"
                  style={{ color: linkColor }}
                >
                  {item.label}
                </a>
              ))}
            </nav>
          )}

          {/* Social Links */}
          {socialLinks.length > 0 && (
            <div className="flex justify-center gap-3 mb-4">
              {socialLinks.map((link) => (
                <a
                  key={link.id}
                  href={link.url || '#'}
                  className="hover:opacity-70 transition-opacity p-2 rounded-full hover:bg-black/5"
                  style={{ color: textColor }}
                  title={link.platform.charAt(0).toUpperCase() + link.platform.slice(1)}
                >
                  <SocialIcon platform={link.platform} size={18} color={textColor} />
                </a>
              ))}
            </div>
          )}

          {/* Copyright */}
          {showCopyright && (
            <p className="text-center text-xs pt-3 border-t border-current/10" style={{ color: copyrightColor, opacity: footerSettings.copyright_color ? 1 : 0.6 }}>
              {copyrightText}
            </p>
          )}
        </div>
      </footer>
    );
  };

  const renderPreview = () => {
    // If menu location is footer, render footer preview
    if (menu.location === 'footer') {
      return renderFooterMenu();
    }
    
    switch (menu.style) {
      case 'hamburger':
        return renderHamburgerMenu();
      case 'sidebar':
        return renderSidebarMenu();
      case 'horizontal':
      default:
        return renderHorizontalMenu();
    }
  };

  return (
    <div className="border rounded-xl p-6 bg-slate-100">
      <div className="mb-4 flex items-center justify-between">
        <span className="text-sm font-medium text-slate-600">
          Preview: {menu.location === 'footer' ? 'footer' : menu.style} menu
        </span>
        <span className="text-xs text-slate-400">
          {menu.location === 'footer' ? 'Footer preview with all settings' : 'Click items to test dropdowns'}
        </span>
      </div>
      <div className={`${menu.location === 'footer' ? 'w-full' : 'flex justify-center'}`}>
        {menu.items?.length > 0 || (menu.location === 'footer' && (menu.footer_settings?.sections?.length > 0 || menu.footer_settings?.social_links?.length > 0)) ? (
          renderPreview()
        ) : (
          <div className="text-slate-400 py-8 text-center">
            {menu.location === 'footer' 
              ? 'Add menu items, content sections, or social links to see the preview'
              : 'Add menu items to see the preview'
            }
          </div>
        )}
      </div>
    </div>
  );
};

export default MenuPreview;
